<template>
    <div v-if="hints.length > 0" class="mb-3">
        <div 
            v-for="(hint, index) in hints" 
            :key="index" 
            class="action-hint-item mb-2"
            :class="{ 'current-user-hint': hint.isForCurrentUser }"
        >
            <b-alert :variant="hint.variant" show class="mb-0 py-2">
                <div class="d-flex align-items-center">
                    <i :class="hint.icon" class="mr-2"></i>
                    <div class="flex-grow-1">
                        <strong>{{ hint.userName }}</strong>{{ hint.message }}
                    </div>
                </div>
            </b-alert>
        </div>
    </div>
</template>

<script>
/**
 * Компонент отображения подсказок для участников
 * Подсказки генерируются на бэкенде и содержат информацию о действиях
 */
export default {
    name: 'ActionHints',
    props: {
        hints: {
            type: Array,
            default: () => []
        }
    }
};
</script>

<style scoped>
.action-hint-item .alert {
    font-size: 0.9rem;
    line-height: 1.5;
    border-left: 4px solid;
}

.action-hint-item .alert-info {
    border-left-color: #17a2b8;
    background-color: #d1ecf1;
}

.action-hint-item .alert-warning {
    border-left-color: #ffc107;
    background-color: #fff3cd;
}

.action-hint-item .alert-success {
    border-left-color: #28a745;
    background-color: #d4edda;
}

.action-hint-item .alert i {
    font-size: 1rem;
}
</style>
